/* EcommerceHeader — Iter 110/Faz4: ana header (logo, son sync, ana butonlar). */
import React from 'react';
import {
    RefreshCw, Loader2, Settings as SettingsIcon, Download, Truck,
} from 'lucide-react';

export default function EcommerceHeader({
    config,
    needsSetup,
    syncing,
    exporting,
    tracking,
    onSync,
    onExport,
    onTrackingRefresh,
    onSettings,
}) {
    return (
        <div className="flex flex-wrap items-center justify-between gap-3 bg-white border border-gray-200 rounded-xl p-4">
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center text-white font-bold">
                    bol
                </div>
                <div>
                    <div className="text-base font-bold text-gray-900">Bol.com Siparişleri</div>
                    <div className="text-xs text-gray-500 flex items-center gap-1.5 mt-0.5">
                        <span className="inline-flex items-center gap-1">
                            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                            Otomatik · {config?.interval_minutes || 60} dk
                        </span>
                        <span className="text-gray-300">·</span>
                        <span>
                            {config?.last_sync_at
                                ? `Son: ${config.last_sync_at.slice(0, 16).replace('T', ' ')}`
                                : 'Henüz sync yok'}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex items-center gap-2">
                <button
                    onClick={onExport}
                    disabled={exporting || needsSetup}
                    className="h-9 px-3 text-sm font-medium text-emerald-700 bg-emerald-50 hover:bg-emerald-100 border border-emerald-200 rounded-lg flex items-center gap-1.5 disabled:opacity-50"
                    data-testid="bol-export-excel-btn"
                    title="Tüm siparişleri Excel olarak indir">
                    {exporting ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
                    Excel
                </button>
                <button
                    onClick={onTrackingRefresh}
                    disabled={tracking || needsSetup}
                    className="h-9 px-3 text-sm font-medium text-sky-700 bg-sky-50 hover:bg-sky-100 border border-sky-200 rounded-lg flex items-center gap-1.5 disabled:opacity-50"
                    data-testid="bol-tracking-refresh-btn"
                    title="Bol'dan kargo event'lerini (DELIVERED, IN_TRANSIT...) çek">
                    {tracking ? <Loader2 size={14} className="animate-spin" /> : <Truck size={14} />}
                    Tracking Yenile
                </button>
                <button
                    onClick={onSettings}
                    className="h-9 px-3 text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg flex items-center gap-1.5"
                    data-testid="bol-settings-btn">
                    <SettingsIcon size={14} /> Ayarlar
                </button>
                <button
                    onClick={onSync}
                    disabled={syncing || needsSetup}
                    className="h-9 px-4 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 rounded-lg flex items-center gap-1.5"
                    data-testid="bol-sync-btn">
                    {syncing ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />}
                    Şimdi Çek
                </button>
            </div>
        </div>
    );
}
